import axios from '@/libs/api.request'
const materialTemplate = {
    // 获取模板列表
    getMaterialTemplate: () => {
        return axios.get({
            url: '/MaterialTemplate'
        })
    },
    // 模板明细
    getMaterialTemplateDetail: (id) => {
      return axios.get({
          url: '/MaterialTemplate/detail?Id='+id
      })
  }
}
export default materialTemplate


// WEBPACK FOOTER //
// ./src/api/api-materialTemplate.js